<template>
  <div class="list-item">
    <v-icon class="mr-2" :color="color">
      {{ icon }}
    </v-icon>
    <v-list-item-content @click="handleSelectDocument">
      <div class="item-right">
        <div>
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            {{ document.name }}
          </div>
          <span class="status" v-if="!isInformation">
            {{ document.status | startCase }}
          </span>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { getIconByStatus } from "@/utils/offers";

export default {
  props: {
    document: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    },
    color() {
      return this.document.status === "complete" ? "success" : "grey";
    },
    isInformation() {
      return this.document.documentType === "information";
    },
    icon() {
      return this.isInformation
        ? getIconByStatus("information")
        : getIconByStatus(this.document.status);
    }
  },
  methods: {
    handleSelectDocument() {
      this.$router.push(
        `/offers/${this.currentOfferId}/document/${this.document.id}`
      );
    }
  }
};
</script>

<style lang="scss">
.offers {
  .list-item {
    :hover {
      cursor: pointer;
    }
    h5 {
      color: $primary;
    }
    .status {
      font-size: 14px;
      color: $secondary-text;
    }
  }
}
</style>
